export const RecommendationApiPath = {
  GET_RECOMMENDATIONS: '/api/recommendations/{session_id}', // GET Get Recommendations
  GET_SIMILAR_PRODUCTS: '/api/recommendations/similar/{product_id}' // GET Get Similar Products
}

export type RecommendationApiPath =
  (typeof RecommendationApiPath)[keyof typeof RecommendationApiPath]

export interface GetRecommendationsVars {
  /** 計測のセッションID（`w2_vid` ではなく sessionStorage の `w2_session_id`）。
   *  旧 `users.id` は廃止され、イベントは `events.session_id` で束ねる */
  session_id: string
  n?: number
  site_id?: number
  ab_group?: string
}

export interface GetSimilarProductsVars {
  product_id: number
  n?: number
  site_id?: number
}

export interface RecommendedProduct {
  product_id: number | null
  external_id: string | null
  name: string | null
  category: string | null
  price: number | null
  image_url: string | null
  product_url: string | null
  score: number
  reason: string | null
}

export interface GetRecommendationsResponse {
  display_logic: string
  recommendations: RecommendedProduct[]
  product_ids: number[]
  fallback?: boolean
}

export type GetSimilarProductsResponse = GetRecommendationsResponse
